import {useMemo, useRef} from 'react';
import {useLocation} from 'react-router-dom';

import {useOnMount} from 'shared/web';

import {UseScrollToSectionType} from '../types/CommonVehicleTypes';

export const useScrollToSection = (): UseScrollToSectionType => {
  const location = useLocation();
  const slug = location.hash ? location.hash.slice(1) : null;
  const sectionRef = useRef<HTMLDivElement>(null);

  const refs: UseScrollToSectionType['refs'] = useMemo(
    () => (slug ? {[slug]: sectionRef} : {}),
    [slug, sectionRef]
  );

  const triggerScroll = () => {
    if (sectionRef?.current?.scrollIntoView) {
      sectionRef.current.scrollIntoView({behavior: 'smooth'});
    }
  };

  useOnMount(triggerScroll);

  return {
    refs,
    triggerScroll,
  };
};
